import { Injectable, ReflectiveInjector } from '@angular/core';
import { Headers, RequestOptions, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { SessionService } from './session.service';
import { environment } from '../../environments';

import 'rxjs/add/operator/map';


// TODO Make semantic functions DRY.

@Injectable()
export class ApiClient {
  store;
  headers: Headers;
  options: RequestOptions;
  total: number;

  model;
  baseUrl: string = environment.apiUrl;
  path: string;
  sessionService: SessionService;

  constructor(protected http: Http) {
    this.headers = new Headers({ 'Content-Type': 'application/json' });

    const injector = ReflectiveInjector.resolveAndCreate([SessionService]);
    this.sessionService = injector.get(SessionService);

    // Append `Authorization` headers.
    const token: string = this.sessionService.token;
    if (token)
      this.headers.append('Authorization', `Bearer ${token}`);

    this.options = new RequestOptions({headers: this.headers});
  }

  load(options?) {
    return this.http.get(this.url, this.options.merge(options))
      .map(res => res.json())
      .map(res => {
        this.total = res.count;
        return res;
      })
      .map(res => res.data instanceof Array ? res.data : res)
      .map(res => this.model ? res.map(o => new this.model(o)) : res)
      .subscribe(res => this.store.next(res));
  }

  list(options?) {
    return this.http.get(this.url, this.options.merge(options))
      .map(res => res.json())
      .map(res => res.data instanceof Array ? res.data : res)
      .map(res => this.model ? res.map(o => new this.model(o)) : res);
  }

  paginate(options?) {
    return this.http.get(this.url, this.options.merge(options))
      .map(res => res.json())
      .map(res => {
        if (res instanceof Array) {
          return this.model ? res.map(o => new this.model(o)) : res;
        } else {
          return this.model ? res.data.map(o => new this.model(o)) : res;
        }
      });
  }

  create(body: any, options?) {
    return this.http.post(this.url, body, this.options.merge(options))
      .map(res => res.json())
      .map(res => this.model ? new this.model(res) : res);
  }

  detail(id: string, options?) {
    return this.http.get(this.idUrl(id), this.options.merge(options))
      .map(res => res.json())
      .map(res => this.model ? new this.model(res) : res);
  }

  update(id: string, body: any, options?) {
    return this.http.patch(this.idUrl(id), body, this.options.merge(options))
      .map(res => res.json())
      .map(res => this.model ? new this.model(res) : res);
  }

  replace(id: string, body: any, options?) {
    return this.http.put(this.idUrl(id), body, this.options.merge(options))
      .map(res => res.json())
      .map(res => this.model ? new this.model(res) : res);
  }

  destroy(id: string, options?) {
    return this.http.delete(this.idUrl(id), this.options.merge(options))
      .map(res => res.json());
  }

  get(url: string, options?: Object) {
    return this.http.get(url, this.options.merge(options))
      .map(res => res.json())
      .map(res => res.data instanceof Array ? res.data : res);
  }

  post(url: string, body: any, options?: Object) {
    return this.http.post(url, body, this.options.merge(options))
      .map(res => res.json());
  }

  put(url: string, body: any, options?: Object) {
    return this.http.put(url, body, this.options.merge(options))
      .map(res => res.json());
  }

  patch(url: string, body: any, options?: Object) {
    return this.http.patch(url, body, this.options.merge(options))
      .map(res => res.json());
  }

  delete(url: string, options?: Object) {
    return this.http.delete(url, this.options.merge(options))
      .map(res => res.json());
  }

  private get url() {
    return `${this.baseUrl}${this.path}`;
  }

  private idUrl(id: string) {
    return `${this.url}/${id}`;
  }

  get data() {
    return this.store.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/api/api-client.ts